function toggleMute(btn) {
  const container = btn.closest(".product_video_inner");
  if (!container) return;
  const video = container.querySelector("video");
  if (!video) return;
  const mutedIcon = btn.querySelector(".muted_icon");
  const unmutedIcon = btn.querySelector(".unmuted_icon");
  if (video.muted) {
    video.muted = false;
    if (mutedIcon) mutedIcon.style.display = "none";
    if (unmutedIcon) unmutedIcon.style.display = "block";
  } else {
    video.muted = true;
    if (mutedIcon) mutedIcon.style.display = "block";
    if (unmutedIcon) unmutedIcon.style.display = "none";
  }
}

function initProductVideoBlocks() {
  const blocks = document.querySelector(".product_video_blocks");
  if (!blocks) return;
  if (typeof Swiper === 'function') {
    new Swiper(blocks, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 10,
      breakpoints: {
        1200: { slidesPerView: 3 },
        576: { slidesPerView: 3 },
        480: { slidesPerView: 3 }
      }
    });
  } else {
    window.addEventListener('load', initProductVideoBlocks, { once: true });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initProductVideoBlocks();

  function playProductVideos() {
    const videos = document.querySelectorAll(".product_video_inner video");
    if (!videos.length) return;
    videos.forEach(function (video) {
      if (video.paused) {
        video.play().catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    });
  }

  if (document.querySelector(".product_video_inner video")) {
    playProductVideos();
    document.addEventListener("variant:change", playProductVideos);
    document.addEventListener("product:updated", playProductVideos);
  }
});